import { Tooltip } from 'tdesign-react';

import { asyncDate, thousandSplit as toThousand, timetampToTime } from '../../utils';
import { Clip } from '../clip';
import SvgIcon from '../tools/svg-icon';

/**
 * 复制
 * @param text 粘贴板文案
 * @param clipText 外显文案
 * @returns
 */
function clipCustom(text: string, clipText?: string) {
  if (!text) return '--';
  const copyText = clipText || text;
  return (
    <Clip post={copyText}>
      <div>
        {text}&nbsp;
        <SvgIcon name="copy" width="14px" height="14px" />
      </div>
    </Clip>
  );
}


function clipCustomEmpty(clipText: string) {
  return (
    <Clip post={clipText}>
      <SvgIcon name="copy2" width="20px" height="20px" />
    </Clip>
  );
}


function clip(text: string) {
  if (!text) return '--';
  return clipCustom(text);
}

/**
 * 复制长文本
 * @param text 粘贴板文案
 * @param clipText 外显文案
 * @returns
 */
function clipTipsDetail(text: string) {
  if (!text) return '--';
  const copyText = text;
  const tmpText = copyText.length > 14 ? `${copyText.slice(0, 14)}···` : copyText;
  return clipCustom(tmpText, copyText);
}

/**
 * 将时间戳格式化日期类型。
 * 1678167775 => '2023-03-07 13:42:55'
 * @param text string | number 自动识别秒/毫秒
 * @returns
 */
function timestampToDate(text: string) {
  return asyncDate(text, 'YYYY-MM-DD HH:mm:ss');
}

/**
 * 数字格式化，便于统计数量
 * @param text 200000000 => 200,000,000
 * @returns
 */
function thousandSplit(text: string) {
  return toThousand(text) || 0;
}

function statusRender(text: string, enumMap: any, colorMap: any) {
  return <span style={{ color: colorMap[text] }}>{enumMap[text]}</span>;
}

function tipsDetail(text: string | []) {
  let tmpText = text || '--';
  if (Array.isArray(text)) {
    tmpText = text.join('，');
  }
  if (tmpText.length < 13) {
    return tmpText;
  }
  return (
    <div className="table-ellipsis">
      <Tooltip content={tmpText}>{(tmpText as string).substring(0, 13)}...</Tooltip>
    </div>
  );
}

function videoBlank(text: string, record: any) {
  const vid = record.vid || record.VID || text;
  if (!vid) {
    return text || '-';
  }
  return (
    <Tooltip content={'点击跳转到视频页'}>
      <a target="_blank" href={`https://v.qq.com/x/page/${vid}.html`}>
        {text}
      </a>
    </Tooltip>
  );
}

function timetampToTimeBySecond(text: string) {
  return timetampToTime(text, 'seconds');
}

export {
  clip,
  clipCustom,
  clipCustomEmpty,
  clipTipsDetail,
  statusRender,
  thousandSplit,
  timestampToDate,
  timetampToTime,
  timetampToTimeBySecond,
  tipsDetail,
  videoBlank,
};

